import { trpc } from '@/shared/api/trpc';

export const useUpdateTaskCollection = () => {
  const utils = trpc.useUtils();
  return trpc.taskCollections.update.useMutation({
    onSettled: (row) => {
      utils.taskCollections.list.invalidate();
      // statusConfig changes can affect which collections an itinerary
      // sees as available, so invalidate the per-itinerary cache too.
      utils.taskCollections.availableForItinerary.invalidate();
      if (row?.id) utils.taskCollections.byId.invalidate({ id: row.id });
    },
  });
};
